<template>
  <BCard>
    <BListItem
      class="title mb-400"
    >
      {{ $t(`client.manualClientDataPurge.title`) }}
    </BListItem>
    <BListItem
      class="message mb-400"
    >
      <div class="warning mb-400">
        <BIcon
          class="mr-100"
          size="small"
          type="error"
        >
          warning
        </BIcon>
        <span
          class="error-text"
        >
          {{ $t('client.manualClientDataPurge.warning') }}
        </span>
      </div>
      <p>{{ $t('client.manualClientDataPurge.description') }}</p>
    </BListItem>
    <BListItem>
      <BLayout
        align-center
        justify-center
      >
        <BBtn
          class="mr-400"
          text
          @click="cancel"
        >
          {{ $t(`general.cancel.text`) }}
        </BBtn>
        <BBtn
          class="ml-400"
          type="primary"
          @click="purgeConfirm"
        >
          {{ $t(`general.delete.do`) }}
        </BBtn>
      </BLayout>
    </BListItem>
  </BCard>
</template>

<script>
export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  emits: [
    'cancel',
    'purge',
  ],
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    async purgeConfirm() {
      const accepted = await this.$bitterAlert.show({
        title: this.$t('client.manualClientDataPurge.confirmTitle'),
        text: this.$t('client.manualClientDataPurge.confirmText', { clientName: this.client.name }),
      });
      if (!accepted) { return; }
      this.$emit('purge');
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: $fontsize-400;
  font-weight: $font-weight-bold;
  text-align: center;
}

.message {
  padding: $basespace-400;
  border-radius: $basespace-100;
  background-color: $concrete-light;
  p {
    white-space: pre-wrap;
  }
}

.error-text {
  color: $basecolor-error;
  font-weight: $font-weight-bold;
}
</style>
